import $ from "jquery";
import scrollState from "../../../core/scrollState";
import state from "../../../core/offsetState";

let headerHeight = null;
let fixableDiv;
let fixableDivInHeader;

export const fixDiv = () => {
    let scrolled = $(document).scrollTop();

    if (headerHeight === null || typeof fixableDiv === 'undefined') {
        return;
    }

    if (scrolled >= headerHeight) {
        fixableDivInHeader.addClass("fixable-div--in-header-show");
        fixableDiv.addClass("fixable-div--hide");
    } else if (scrolled < headerHeight) {
        fixableDivInHeader.removeClass("fixable-div--in-header-show");
        fixableDiv.removeClass("fixable-div--hide");
    }
};

const fixableDivExists = () => {
    return ($('.fixable-div').length > 0) && ($('.fixable-div--in-header').length > 0);
};

export const eventFixableDiv = () => {
    if (!fixableDivExists()) {
        return;
    }

    fixableDiv = $('.fixable-div');
    fixableDivInHeader = $('.fixable-div--in-header');

    headerHeight = fixableDiv.offset().top;
    headerHeight -= $('.header-wrapper').height();
    headerHeight += scrollState.getScrollTrackerState().scrollTracker;
    headerHeight -= state.getState().urgentNewsHeight;

    fixDiv();
};
